module.exports = __webpack_public_path__ + "static/2-6f7480b72031915c93c880fe09976e82.jpg";